import history from 'history.js';

/**
 * Builds the deep-link URL to the BPA Findings page for a given integration,
 * pre-filtered to that integration's active findings.
 */
export const getBPAFindingsUrl = (integrationId: number): string => {
  return `bpa-findings?integration=${integrationId}&scan_status=Active`;
};

/**
 * Passes the integration label through router state so the destination page can
 * show a readable Integration filter badge immediately.
 */
export const navigateToBPAFindings = (
  integrationId: number,
  integrationLabel?: string,
) => {
  history.push(getBPAFindingsUrl(integrationId), {
    integrationLabel: integrationLabel ?? undefined,
  });
};
